import { render } from "./BlckSectionItem.vue?vue&type=template&id=63db0171&scoped=true"
import script from "./BlckSectionItem.vue?vue&type=script&lang=js"
export * from "./BlckSectionItem.vue?vue&type=script&lang=js"

import "./BlckSectionItem.vue?vue&type=style&index=0&id=63db0171&scoped=true&lang=css"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63db0171"]])

export default __exports__